import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
import { ConfirmationService, Message, SelectItem } from 'primeng/primeng';
import { EncryptingService } from '../encrypting.service';
import { StoreService } from '../store.service';
import { environment } from 'src/environments/environment.prod';
import {Validators,FormControl,FormGroup,FormBuilder} from '@angular/forms';


@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [ApiService, EncryptingService, ConfirmationService]
})
export class MyAccountComponent implements OnInit {

  loadingMessage: string = "loading...";
  msgs: Message[] = [];
  plans: any = [];
  stripePayment: any = [];
  planSelected: any;
  subscribedPlan: any = null;
  totalPdfUsed: any;
  totalTrialPdfUsed: any;
  myAccountDetail: any;
  userform: FormGroup;
  submitted: boolean;
  genders: SelectItem[];
  description: string;

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService, 
    private api: ApiService, 
    private encrypt: EncryptingService, 
    private ss: StoreService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {

    this.genders = [];
  this.genders.push({label:'Select Gender', value:''});
  this.genders.push({label:'Male', value:'Male'});
  this.genders.push({label:'Female', value:'Female'});
  
   this.getSubscribedPlan();
   this.getTotalPdfUsed();
    this.getMyAccount();
    
    this.getPlans();
    // this.getPayment();
   this.getTotalTrialPdfUsed();
  }

  getPayment() {
    this.spinner.show();
    this.loadingMessage = "Getting Striped Payment..."

    this.api.get('Stripe/GetPayment', '').subscribe(
      (res: {}) => this.sucessGetPayment(res),
      error => this.failedGetPlan(<any>error));
  }

  sucessGetPayment(resp: any) {
    this.stripePayment = resp.Data;

    this.spinner.hide();
  }

  getPlans() {
    this.spinner.show();
    this.loadingMessage = "Getting Suppliers..."

    // this.api.get('Plan/GetAll', '').subscribe(
    //   (res: {}) => this.sucessGetPlans(res),
    //   error => this.failedGetPlan(<any>error));
      const accountID = this.ss.fetchAccountID();
      this.api.getRAHPlan("/Plan/GetPlanForRAH?accountId="+accountID,'')
      .subscribe(
      (res: {}) => this.sucessGetPlans(res),
      error => this.failedGetPlan(<any>error));
  }

  saveFreePlan(body: any): void {
  this.api.postSaveFreePlan("PaymentHistory/SavePaymentDetails", body)
    .subscribe({
      next: (res: any) => {
        // Optionally show a success message here
        window.location.reload();
      },
      error: (err: any) => {
        this.failedGetPlan(err);
      }
    });
}

  sucessGetPlans(resp: any) {
    this.plans = [];
    this.plans.push({ label: '', value: '' });

    resp.result.forEach(element => {
      if(element.isActive==true){
       
        this.plans.push({ label: element.planName, value: element.planID });
      }
    });
  
    console.log("Plan-->",this.plans)

    this.spinner.hide();
  }

  failedGetPlan(resp: any) {
    this.spinner.hide();
  }

  getSubscribedPlan() {
    this.spinner.show();
    this.loadingMessage = "Please wait..."

    this.api.get('Plan/GetAccountSubscribedPlan', '').subscribe(
      (res: {}) => this.sucessGetSubscribedPlan(res),
      error => this.failedGetSubscribedPlan(<any>error));
  }

  sucessGetSubscribedPlan(res: any) {
    this.subscribedPlan = res.Data;
    this.spinner.hide();
  }

  failedGetSubscribedPlan(res: any) {
    this.spinner.hide();
  }

  getTotalPdfUsed() {
    this.spinner.show();
    this.loadingMessage = "Please wait..."

    this.api.get('Plan/GetTotalPaidPdfUsed', '').subscribe(
      (res: {}) => this.sucessGetTotalPdfUsed(res),
      error => this.failedGetTotalPdfUsed(<any>error));
  }

  sucessGetTotalPdfUsed(res: any) {
    if (res.Data != null) {
      this.totalPdfUsed = res.Data.TotalPaidUsedOnCurrentSubscription?res.Data.TotalPaidUsedOnCurrentSubscription:0;
    }
    this.spinner.hide();
  }

  failedGetTotalPdfUsed(res: any) {
    this.spinner.hide();
  }

  getMyAccount() {

    this.spinner.show();
    this.loadingMessage = "Please wait..."

    this.api.get('Account/Get', '').subscribe(
      (res: {}) => this.sucessGetMyAccount(res),
      error => this.failedGetMyAccount(<any>error));
  }

  sucessGetMyAccount(res: any) {
    this.myAccountDetail = res.Data;
    console.log(this.myAccountDetail);
    this.spinner.hide();


  }

  failedGetMyAccount(res: any) {
    this.spinner.hide();
  }

  buyWithCard() {
    

    console.log(this.planSelected);
    
    if (this.planSelected === null || this.planSelected===''  || this.planSelected === undefined) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select a plan first', detail: 'Mandatory.' });
      return;
    }

    const planSelected =this.planSelected+''

    if (planSelected === null || planSelected===''  || planSelected.length==0) {
      this.msgs = [];
      this.msgs.push({ severity: 'Info', summary: 'Please select a plan first', detail: 'Mandatory.' });
      return;
    }
    else{

      if(planSelected =='70'){
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: ' Please select a paid plan.', detail: 'Mandatory.' });
        return;
      }

      if(planSelected =='76') {
        let paymenthistory = {
          UserId: this.ss.fetchUserName(),
          EmailId: this.ss.fetchEmail(),
          PlanId: 76,
          AccountId: this.ss.fetchAccountID(),
          RegionId: 3,
          PayId: "freePlan",
          IsPaid: false,
          IsAutoRenew: true,

        };

        this.saveFreePlan(paymenthistory)

    }

      


    

    if(!(this.subscribedPlan.IsExpired)){
        const confirmed = confirm(
          'If you buy this new plan, the active plan\'s allocated PDF count will be reset.\n\nAre you sure you want to proceed?'
         );
    
        if (confirmed) {
            //alert('Payment process started!');
            // Proceed with payment logic here
        } else {
            alert('Payment cancelled.');
            return ;
        }
    }



    //TODO:
    // var encryptedData = 1 + '|' + this.planSelected;
    // var token = '?token=' + this.encrypt.encrypt(encryptedData);


    // window.location.href = this.api.stripePaymentUrl + token;

  //   var encryptedData = 1 + '|' + this.planSelected;
  //   console.log('encryptedData');
  //  console.log(encryptedData);
  //   var token1 = this.ss.fetchToken();
  //   //var token =  this.encrypt.encrypt(token1);

  //   window.location.href = this.api.stripePaymentUrl + token1 + "&plan="+this.planSelected ;

      window.location.href = this.api.paymentUrl+"plan?UserId="+ this.ss.fetchUserName() +
            "&Email=" + this.ss.fetchEmail() + "&Platform=reckon"+"&SelectedPlan="+this.planSelected+
            "&Region=AUS&ReturnUrl=" + encodeURIComponent(this.api.paymentreturnURL) + "&AccountId=" + this.ss.fetchAccountID();

  }
}

  getTotalTrialPdfUsed() {
    this.spinner.show();
    this.loadingMessage = "Please wait..."

    this.api.get('Plan/GetTotalTrialPdfUsed', '').subscribe(
      (res: {}) => this.sucessGetTotalTrialPdfUsed(res),
      error => this.failedGetTotalTrialPdfUsed(<any>error));
  }

  sucessGetTotalTrialPdfUsed(res: any) {
    if (res.Data != null) {
      this.totalTrialPdfUsed = res.Data.TotalPaidUsedOnCurrentSubscription;

      console.log('this.totalTrialPdfUsed'+this.totalTrialPdfUsed)

    }
    this.spinner.hide();
  }

  failedGetTotalTrialPdfUsed(res: any) {
    this.spinner.hide();
  }

  confirmCancel(){
    this.confirmationService.confirm({
      message: 'Are you sure you want to cancel your subscription?',
      accept: () => this.cancelSubscription(),
      reject: () => {
        // Optional: handle rejection (e.g., log or do nothing)
      }
    });
  }

  cancelSubscription() {
    const accountID =this.ss.fetchAccountID();
    this.api.get('Plan/CancelActiveSubscribtion?accountId='+accountID, '').subscribe(
      (res: {}) =>{ console.log(res); window.location.reload();},
      error => console.log(<any>error));
  }

}
